const prefixUses: Record<string, number> = {};

export function generateId(prefix: string): string {
  prefixUses[prefix] = (prefixUses[prefix] ?? -1) + 1;
  return `${prefix}_${prefixUses[prefix]}`;
}
